/*
 * This script dynamically adds a 'columns-block-row--reverse' class to specific '.columns-block-row' containers.
 * The class is added under the condition that a '.column-content' without a '.wp-block-image'
 * is followed by one that includes a '.wp-block-image'. This is designed to work with responsive designs,
 * applying the class 'columns-block-row--reverse'.
 */

window.addEventListener('load', function() {
    // Select all '.columns-block-row' elements within '.image-text' containers
    const rows = document.querySelectorAll('.image-text .columns-block-row');
  
    rows.forEach(row => {
        const columnContents = row.querySelectorAll('.column-content');
        let applyClass = false;

        // Check each pair of '.column-content' elements to see if they meet the condition
        for (let i = 0; i < columnContents.length - 1; i++) {
            const current = columnContents[i];
            const next = columnContents[i + 1];

            // If the current element does not contain a '.wp-block-image' and the next one does, flag to apply the class
            if (!current.querySelector('.wp-block-image') && next.querySelector('.wp-block-image')) {
                applyClass = true;
                break; // Exit the loop if condition is met
            }
        }
  
        // Add 'columns-block-row--reverse' class to the row if the condition is true
        if (applyClass) {
            row.classList.add('columns-block-row--reverse');
        }
    });
});
